<div #container class="container">
  <form [formGroup]="searchForm">
    <mat-form-field [hideRequiredMarker]="true">
      <mat-icon matPrefix>search</mat-icon>
      <input
        #searchInput
        placeholder="Pesquise o que deseja encontrar"
        autocomplete="off"
        matInput
        type="text"
        formControlName="searchTerm"
      />
      <button mat-icon-button matSuffix (click)="handleClose()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </form>
  <div class="results-container">
    <app-search-results *ngIf="!!(isOpened$ | async)"></app-search-results>
  </div>
</div>
